'use client';

import Link from 'next/link';
import Image from 'next/image';
import { APP_META } from '@/lib/config';

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-zinc-200/70 dark:border-white/[0.08] bg-zinc-100 dark:bg-zinc-900">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          {/* Brand */}
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <Image src="/brand/draamview-icon.png" alt="" width={28} height={28} className="h-7 w-7 rounded-lg" />
              <span className="font-display text-xl text-zinc-900 dark:text-white">
                Draam<span className="italic text-emerald-700 dark:text-emerald-400">view</span>
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-zinc-500 dark:text-zinc-400">
              Small & microcap intelligence — screeners, surveillance trackers and
              smart-money signals in one calm workspace.
            </p>
          </div>

          {/* Links */}
          <nav className="flex gap-10 text-sm">
            <div className="flex flex-col gap-2.5">
              <span className="text-xs font-semibold uppercase tracking-wider text-zinc-400 dark:text-zinc-500">
                Explore
              </span>
              <Link href="/tools" className="text-zinc-600 dark:text-zinc-300 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                Tools
              </Link>
              <Link href="/watchlist" className="text-zinc-600 dark:text-zinc-300 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                Watchlist
              </Link>
            </div>
            <div className="flex flex-col gap-2.5">
              <span className="text-xs font-semibold uppercase tracking-wider text-zinc-400 dark:text-zinc-500">
                Company
              </span>
              <Link href="/contact" className="text-zinc-600 dark:text-zinc-300 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                Contact
              </Link>
              <Link href="/login" className="text-zinc-600 dark:text-zinc-300 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                Sign in
              </Link>
              <Link href="/privacy" className="text-zinc-600 dark:text-zinc-300 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                Privacy
              </Link>
              <Link href="/delete-account" className="text-zinc-600 dark:text-zinc-300 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                Delete account
              </Link>
            </div>
          </nav>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-zinc-200/70 dark:border-white/[0.08] pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-zinc-400 dark:text-zinc-500">
            © {new Date().getFullYear()} {APP_META.NAME} · v{APP_META.VERSION}
          </p>
          <p className="max-w-2xl text-xs leading-relaxed text-zinc-400 dark:text-zinc-500">
            Research offered is purely educational. We do not provide investment advice.
            Past performance isn&apos;t indicative of future returns.
          </p>
        </div>
      </div>
    </footer>
  );
}
